export default __webpack_public_path__ + "static/media/Vambraces of the Fallen Empire.64bb8462.jpg";